import { AppActionTypes, actionTypes, LocationsFetchAction, LocationsFetchSuccessAction, LocationPositionsFetchSuccessAction, ToggleSidebarAction, VendorsFetchSuccessAction } from './actions';

import { Vendor } from 'src/lib/interfaces/Vendor.interface'

const sortBy = require('lodash/sortBy')

interface PositionsType {
  [key: number]: Position[]
}

export interface AppState {
  readonly isMobile: boolean
  readonly vendors?: Vendor[]
  readonly sidebarOpen: boolean
  readonly locations?: Location[]
  readonly positions?: PositionsType
}

export const initialState: AppState = {
  isMobile: false,
  sidebarOpen: true,
  vendors: undefined,
  locations: undefined,
  positions: undefined
}

export function reducer(state: AppState = initialState, action: AppActionTypes): AppState {
  switch (action.type) {
    case actionTypes.LOCATIONS_FETCH:
      return {
        ...state,
        locations: undefined
      }
    case actionTypes.LOCATIONS_FETCH_SUCCESS:
      return {
        ...state,
        locations: (action as LocationsFetchSuccessAction).payload.locations
      }
    case actionTypes.TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarOpen: (action as ToggleSidebarAction).payload.state
      }

    case actionTypes.LOCATION_POSITIONS_FETCH_SUCCESS:
      const positionsActionPayload = (action as LocationPositionsFetchSuccessAction).payload

      return {
        ...state,
        positions: {
          ...state.positions,
          [positionsActionPayload.locationId]: sortBy(positionsActionPayload.positions, 'name')
        }
      }

    case actionTypes.VENDORS_FETCH_SUCCESS:
      return {
        ...state,
        vendors: (action as VendorsFetchSuccessAction).payload.vendors
      }

    // case actionTypes.LOCATIONS_FETCH_ERROR:
    //   return {
    //     ...state
    //   }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/app/reducer.ts